export default "__VITE_ASSET__DnD9W1DS__"